<template>
    <v-snackbar v-model="snackbar" :timeout="_timeout" location="top" :color="color">
        <div v-for="(notification, index) in notifications" :key="index">
            {{ notification }}
        </div>
        <template v-if="_timeout === -1" v-slot:actions>
            <v-icon @click="snackbar = false">mdi-close</v-icon>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_NOTIFICATIONS} from '@/utils/event-bus'

    @Component({})
    export class NotificationsSnackbar extends Vue {
        snackbar = false
        notifications = []
        color = 'warning'

        mounted() {
            EventBus.$on(SHOW_NOTIFICATIONS, this.show)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_NOTIFICATIONS, this.show)
        }

        show({notifications, color}) {
            this.color = color || 'warning'
            this.notifications = notifications
            this.snackbar = true
        }

        get _timeout() {
            return this.color === 'error' ? 5000 : -1
        }
    }

    export default NotificationsSnackbar
</script>
